import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { sendClarityEvent, sendGTMEvent } from "../utils/analytics";
import { LegalTexts } from "../components/LegalTexts";
import { t } from "../i18n";
import PhoneLabel from "../components/PhoneLabel";

export const ContactForm = () => {
	const { flow, data, setData, validateForm, errors } = useContext(AppContext);
	const [contactFormSent, setContactFormSent] = useState(false);

	const sendContactForm = () => {
		if (!validateForm()) {
			// console.log("Formulario con errores, deteniendo navegación...");
			return;
		}

		let apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3000";
		let token = process.env.REACT_APP_API_TOKEN;

		let controller = new AbortController();
		let options = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ ...data, token, isContactForm: true }),
			signal: controller.signal,
		};

		fetch(`${apiUrl}/bookings/${data.locator}`, options)
			.then((res) => res.json())
			.then((newData) => {
				contactFormEndpoint();
			})
			.catch((err) => {
				console.error(err);
			});

		const contactFormEndpoint = () => {
			fetch(`${apiUrl}/contact-form/${data.locator}`, options)
				.then((res) => res.json())
				.then((newData) => {
					if (newData.result === "ok") {
						setContactFormSent(true);
						sendClarityEvent("fc-send-contact-form");
						sendGTMEvent("fc-send-contact-form", {
							origin: data.origin,
							locator: data.locator,
						});
						sessionStorage.removeItem("Data");
						sessionStorage.removeItem("Data_expires");
						if (flow !== "mapfre") {
							window.parent.postMessage(
								{
									type: "fc-formulario-contacto-enviado",
									data: {
										origin: data.origin,
										name: data.name,
										email: data.email,
										phone: data.phone,
										booking: data,
									},
								},
								"*"
							);
						}
					}
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					controller.abort();
				});
		};
	};

	useEffect(() => {
		if (!data.locator) {
			let apiUrl =
				process.env.REACT_APP_API_URL || "http://localhost:3000";
			let token = process.env.REACT_APP_API_TOKEN;

			let controller = new AbortController();
			let options = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					...data,
					token,
				}),
				signal: controller.signal,
			};

			fetch(`${apiUrl}/bookings`, options)
				.then((res) => res.json())
				.then((newData) => {
					setData((prevData) => ({
						...prevData,
						locator: newData.locator,
					}));
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					controller.abort();
				});
		}

		sendClarityEvent("fc-iniciar-formulario-contacto");
		sendGTMEvent("fc-iniciar-formulario-contacto", {
			origin: data.origin,
			locator: data.locator,
		});
		// add cross-site message to parent window
		if (flow !== "mapfre") {
			window.parent.postMessage(
				{
					type: "fc-iniciar-formulario-contacto",
					data: {
						origin: data.origin,
					},
				},
				"*"
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<div
				className={
					"content_contact_form" + (contactFormSent ? " hidden" : "")
				}
			>
				<h2 className="contact_form_title">
					{t("Estamos deseando ayudarte")}
				</h2>
				<form>
					<label>
						<strong>
							{t("Nombre")} <span className="required">*</span>
						</strong>
						<input
							type="text"
							defaultValue={data ? data.name : ""}
							onChange={(e) =>
								setData((prev) => ({
									...prev,
									name: e.target.value,
								}))
							}
						/>
						{errors.name && (
							<span className="error">{errors.name}</span>
						)}
					</label>
					<label>
						<strong>
							{t("Email")} <span className="required">*</span>
						</strong>
						<input
							type="email"
							defaultValue={data ? data.email : ""}
							onChange={(e) =>
								setData((prev) => ({
									...prev,
									email: e.target.value,
								}))
							}
						/>
						{errors.email && (
							<span className="error">{errors.email}</span>
						)}
					</label>
					<PhoneLabel isRequired={true} />
					<label>
						<strong>
							{t("Código postal")}{" "}
							<span className="required">*</span>
						</strong>
						<input
							type="text"
							defaultValue={data ? data.postalCode : ""}
							onChange={(e) =>
								setData((prev) => ({
									...prev,
									postalCode: e.target.value,
								}))
							}
						/>
						{errors.postalCode && (
							<span className="error">{errors.postalCode}</span>
						)}
					</label>
					<label className="message">
						<strong>
							{t("Mensaje")} <span className="required">*</span>
						</strong>
						<textarea
							value={data?.message || ""}
							onChange={(e) =>
								setData((prev) => ({
									...prev,
									message: e.target.value,
								}))
							}
						/>
						{errors.message && (
							<span className="error">{errors.message}</span>
						)}
					</label>
					<label className="privacy_policy">
						<input
							type="checkbox"
							checked={!!(data && data.privacy_policy)}
							onChange={(e) =>
								setData((prev) => ({
									...prev,
									privacy_policy: e.target.checked,
								}))
							}
						/>
						<span className="link">
							<span className="link">
								{t("Acepto la")}{" "}
								<a
									href="https://www.ralarsa.com/es/privacidad/"
									target="_blank"
									rel="noopener noreferrer"
								>
									{t("política de privacidad")}
								</a>
							</span>
							<span className="required"> *</span>
						</span>
					</label>
				</form>
				<button
					className={
						"nav_next kensei_03" +
						(!data.name ||
						!data.email ||
						!data.phone ||
						!data.postalCode ||
						!data.message ||
						!data.privacy_policy
							? " disabled"
							: "")
					}
					onPointerDown={sendContactForm}
				>
					{t("Enviar consulta")}
				</button>
				{(errors.name || errors.email || errors.message) && (
					<span className="error">
						{t(
							"Corrige los errores antes de enviar este formulario."
						)}
					</span>
				)}
				<LegalTexts />
			</div>
			<div
				className={
					"contact_form_sent" + (contactFormSent ? " shown" : "")
				}
			>
				<h2>{t("El formulario se ha enviado correctamente")}</h2>
				<p>{t("Nos pondremos en contacto contigo lo antes posible")}</p>
			</div>
		</>
	);
};
